import { render, staticRenderFns } from "./DocumentsSearch.vue?vue&type=template&id=a58895a0&"
import script from "./DocumentsSearch.vue?vue&type=script&lang=js&"
export * from "./DocumentsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports